import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-28 text-center" data-testid="not-found-page">
      <p className="font-serif text-[7rem] leading-none font-bold text-[#E0A96D]">404</p>
      <h1 className="font-serif text-3xl font-bold text-stone-900 mt-4">This page wandered off the gift shelf.</h1>
      <p className="text-stone-500 mt-3">Let's get you back to the good stuff.</p>
      <Link to="/" className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-[#B45309] text-white text-sm font-bold hover:bg-[#92400E] transition-colors" data-testid="notfound-home">
        <Compass size={16} /> Back to Home
      </Link>
    </div>
  );
}
